import React from "react";

function Hero() {
  return (
    <div>
    <div className="bg-[#040909] min-h-screen">
      <img className="w-80 absolute" src="/images/border-circle.png" alt="" />
      <div><h1 className="text-white text-8xl font-kry text-center pt-14">Rishabh Sharma</h1></div>
      <img className="w-[20rem] pt-14 text-center mx-auto rounded-sm z-10 relative" src="/images/IMG_6340.JPG" alt="" />
      <img className=" top-[-327px] relative w-[39rem] mx-auto" src="/images/Vector 3.svg" alt="" />
      <img className="absolute top-40 right-0 w-80" src="/images/Group 7.png" alt="" />
    </div>
    </div>
  );
}

export default Hero;
